import { memo } from 'react';
import type { FC, ReactNode } from 'react';

import resets from '../../_resets.module.css';
import classes from './Button_ContentTextSizeLargeTyp.module.css';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
  text?: {
    button?: ReactNode;
  };
}

const marginTop10: React.CSSProperties = {
  marginTop: '5%'
};
/* @figmaId 1:125 */
export const Button_ContentTextSizeLargeTyp: FC<Props> = memo(function Button_ContentTextSizeLargeTyp(props = {}) {
  return (
    <button style={marginTop10} className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`} type="submit">
      {props.text?.button != null ? props.text?.button : <div className={classes.button}>Button</div>}
    </button>
  );
});
